/* eslint-disable */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-console */

import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';;

import {
  Grid,
  RACButton,
  RACModalCard,
  Typography,
  Card,
  RACTable,
  RACTableCell,
  RACTableRow,
  RACSelect,
} from "@rentacenter/racstrap";
import {
  ModalRadius,
  CardHeaderData,
  ReverseReasonObject,
  ParamType,
} from "../../constants/constants";
import { useParams } from "react-router-dom";
import { b64toBlob, getContentType } from "../../utils/utils";
import { reversePaymentStyle } from "../../stylesJS/reversePaymentStyle";
import { ReactComponent as AlertIcon } from "../../assets/images/no-records-found.svg";
import { GeneralStateContext } from "../../context/GeneralProvider";
import { GeneralStateDispatchContext } from "../../context/GeneralProvider";
import { CustomerdataContext } from "../../context/customer/customerdata";
import { agreementContext } from "../../refactoredComponents/context/PaymentInformationContext";
import {
  ReverseCCPayment,
  postReversePayment,
  // ReceiptGeneration,
  Swipecustomercard,
  getDocument,
  storeException
} from "../../api/user";
import StoreException from "../microfrontends/StoreException";
import { loadVantivIFrame, getRegistrationId } from "../microfrontends/vantiv-iframe.service";
import CONSTANTS from "../../refactoredComponents/constants/constant";
import { ProcessPaymentLogRequest } from "../../refactoredComponents/interface/tenderCardInterface";
import { CreditCard } from "../microfrontends/CreditCard";
export default function CardReversalComponent() {
  const { t } = useTranslation("Reverse")
  const classes = reversePaymentStyle();
  const [StoreExceptionEnable, setStoreExceptionEnable] = React.useState(false)
  const { StoreExceptionPayload, setStoreExceptionPayload } = React.useContext(CustomerdataContext)
  const [cardInformationPopup, setCardInformationPopup] = React.useState(false);


  let stopFlag = false;
  const { customerId } = useParams<ParamType>();
  const {
    cardReversal,
    pendingReversal,
    cardTransactionFailed,
    reversePayData,
    failedCCAttempt,
    continueController,
    CCAmount,
    loadingModal,
    disableContinueButton,
    transferCOAModel,
    selectedMasterCheckBox,
    gridCardDetails,
    exceptionModal,
    reverseReasonValue,
    selectedAgreements,
    isClubReversible,
    cardReversalDetails,
    employeeId,
    amountToDisplay,
    customerInformation,
    // actionTBTOpen,
    openTerminalPopup,
    availableSwipeDevices,
    selectedTerminal,
    selectedTransactionType,
    choosenSwipeData,
    otherAmountToBeAdded,
    otherAmountToBeSub,
    otherSusPayAmt,
    isCloudReverseCCPayment,
    isCloudReverseSwipePayment,
    isSwipeCustomerCard,
    registerNumber,
    selectedInventories,
    isEnableCashAppFeature,
    isMXStore: isMXStoreContext
  } = useContext(GeneralStateContext);
  const {
    setCardReversal,
    setPendingReversal,
    setCardTransactionFailed,
    setFailedCCAttempt,
    setContinueController,
    setCCAmount,
    setLoadingModal,
    setTransferCOAModel,
    setReverseReasonValue,
    setExceptionModal,
    setOpenViewReceipt,
    setReverseReceiptURL,
    setCardReversalDetails,
    setAmountToDisplay,
    setIsPostReversalFailed,
    //setActionTBTOpen,
    setOpenTerminalPopup,
    setSelectedTerminal,
    // setSelectedTransactionType,
    setChoosenSwipeData,
    setRegisterNumber,
    setFailedReceiptFetching,
    setReversedReceiptID
  } = useContext(GeneralStateDispatchContext);
  const [vantivframe, setVantivIframe] = React.useState();
  const [vantivError, setVantivError] = React.useState<string>(
    CONSTANTS.EMPTY_STRING
  );
  const [modalCardSize, setModalCardSize] = useState<any>({ size: "lg", topic: t('Reverse Payment') })

  const { featureFlags } = useContext(agreementContext);

  const isMXStore = isMXStoreContext || featureFlags?.MXStoreIdentifier === "1";

  useEffect(() => {
    console.log("reversePayData logger in cc", gridCardDetails);
    if (gridCardDetails) {
      console.log("count logger gridCardDetails", gridCardDetails);

      setFailedCCAttempt(new Array(gridCardDetails.length).fill(0));
      setContinueController(new Array(gridCardDetails.length).fill(0));
    }
    setRegisterNumber(String(window.sessionStorage.getItem("registerNumber")))
  }, [gridCardDetails]); // This method will be calculating the number of failed and success attempts in the card reversal.

  useEffect(() => {
    const filteredData = availableSwipeDevices?.filter((el) => String(el.termNumber)?.slice(-3) === selectedTerminal);
    if (filteredData && filteredData.length) {
      setRegisterNumber(filteredData[0].registerNumber)
    } else if (String(window.sessionStorage.getItem("registerNumber"))) {
      setRegisterNumber(String(window.sessionStorage.getItem("registerNumber")))
    } else {
      setRegisterNumber(undefined);
    }
  }, [selectedTerminal])

  useEffect(() => {
    console.log("amountToDisplay", amountToDisplay);
    // const allowCalculate = amountToDisplay.every((el) => el === 0);
    // if (allowCalculate) {
    const calculatedAmtToDisplay: any = [];
    let amountToReverse = CCAmount.totalCardPayEligible;
    gridCardDetails.map((obj) => {
      if (
        Number(amountToReverse) -
        (Number(obj.cardAmount) - Number(obj.cardAmountReversed)) >
        0
      ) {
        calculatedAmtToDisplay.push(
          Number(obj.cardAmount) - Number(obj.cardAmountReversed)
        );
        amountToReverse =
          Number(amountToReverse) -
          (Number(obj.cardAmount) - Number(obj.cardAmountReversed));
      } else {
        calculatedAmtToDisplay.push(Number(amountToReverse));
        amountToReverse = 0;
      }
    });
    setAmountToDisplay(calculatedAmtToDisplay);
    // }
  }, [gridCardDetails]); // This method will be calculating the amount to display in the grid of card reversal.

  useEffect(() => {
    if (cardInformationPopup) {
      callVantivIframe();
    }
  }, [cardInformationPopup])


  const callVantivIframe = () => {
    //  if (iframeType == 2) {
    setVantivIframe(
      loadVantivIFrame(
        CONSTANTS.VANTIV_NUMBER,
        CONSTANTS.VANTIV_CHARGE_FRAME,
        handleVantivChargeCallback
      )
    );
    // }
    return 1;
  };

  const handleVantivChargeCallback = (response: any) => {
    console.log(response, 'vantiv charge response');
    // setDisableSave(false);
    if (response.response === CONSTANTS.VANTIV_RESPONSE_CODE_870) {
      const card = new CreditCard(response);
      let cardRef = CONSTANTS.UNKNOWN_REF;
      switch (card.type) {
        case CONSTANTS.ONE_STRING:
          cardRef = "M";
          break;
        case CONSTANTS.TWO_STRING:
          cardRef = "V";
          break;
        case CONSTANTS.THREE_STRING:
          cardRef = "A";
          break;
        case CONSTANTS.FOUR_STRING:
          cardRef = "D";
          break;
        case CONSTANTS.FIVE_STRING:
          cardRef = "DC";
          break;
        case CONSTANTS.SIX_STRING:
          cardRef = "J";
          break;
        case CONSTANTS.SEVEN_STRING:
          cardRef = "PP";
          break;
        case CONSTANTS.TEN_STRING:
          cardRef = "C";
          break;
        case CONSTANTS.ELEVEN_STRING:
          cardRef = "U";
          break;
      }
      const request = {
        paymentToken: response.paypageRegistrationId,
        cardType: card.type,
        expirationDate: card.cardExpiration,
        tokenType: CONSTANTS.TOKEN_TYPE,
      };
      invokeSwipeReversal(choosenSwipeData.swipeIndex,
        choosenSwipeData.swipeData, request)

      console.log("request", request)
      // vantivChargeSubmit(request);
      // alert('Reversing.....')
      carInformationCancelClick()
    } else {
      // props.setSaveCardPopupShow({
      //   ...props.saveCardPopupShow,
      //   saveCardPopUp: true,
      // });
      handleVantivErrorResponse(response.response);
    }
  };
  const handleVantivErrorResponse = (responseCode: string | number) => {
    const isCreditCardNumberError = CONSTANTS.CREDIT_CARD_ERROR_REPONSE.some(
      (errorCode) => errorCode === responseCode
    );
    const isCVVError = CONSTANTS.CVV_ERROR_RESPONSE.some(
      (errorCode) => errorCode === responseCode
    );
    if (isCreditCardNumberError) {
      setVantivError(
        CONSTANTS.PLEASE_CHECK_AND_REENTER_YOUR_CREDIT_CARD_NUMBER_AND_TRY_AGAIN
      );
    } else if (isCVVError) {
      setVantivError(
        CONSTANTS.PLEASE_CHECK_AND_REENTER_YOUR_CARD_VALIDATION_NUMBER_AND_TRY_AGAIN
      );
    } else if (responseCode === CONSTANTS.VANTIV_RESPONSE_CODE_884) {
      setVantivError(CONSTANTS.VANTIV_RESPONSE_CODE_884);
    } else {
      setVantivError(
        CONSTANTS.WE_ARE_EXPERIENCING_TECHINCAL_DIFFICULTIES_PLEASE_TRY_AGAIN
      );
    }
    setCardTransactionFailed(true)
  };
  const invokeCCReversal = async (index, cardData) => {
    const amountToReverse = CCAmount.totalCardPayEligible;
    let refundAmt = 0;
    if (
      Number(amountToReverse) -
      (Number(cardData.cardAmount) - Number(cardData.cardAmountReversed)) >
      0
    ) {
      refundAmt =
        Number(cardData.cardAmount) - Number(cardData.cardAmountReversed);
    } else {
      refundAmt = Number(amountToReverse);
    }

    const CCData = {
      OriginalExternalTransactionID: cardData.externalTransactionId,
      ExternalTransactionID: cardData.externalTransactionId,
      CustomerID: customerId,
      OriginalAmount: cardData.cardAmount,
      RefundAmount: refundAmt.toFixed(2),
      UserID: employeeId,
      CloudReverseCCPayment: isCloudReverseCCPayment,
      reverseSwipePayload: false
    };
    setCardReversal(false);
    setLoadingModal({ ...loadingModal, reversePay: true });
    const postReversal = await ReverseCCPayment({
      swipeReversalData: null,
      normalReversalData: CCData,
    });
    setLoadingModal({ ...loadingModal, reversePay: false });
    console.log("postReversal", postReversal);
    if (postReversal.status === 200) {
      console.log("continueController value", continueController);

      const iniVal: any = [...[], ...continueController];
      iniVal[index] = 1;
      console.log("iniVal iniVal", iniVal);

      const updatedCardReversalDetails: any = [...[], ...cardReversalDetails];
      let externalTransactionId = null;
      let cardToken = null;
      if (isCloudReverseCCPayment == 0) {
        externalTransactionId = postReversal?.data?.ExternalTransactionID ? postReversal.data.ExternalTransactionID : null;
        // cardToken = 
      } else {
        externalTransactionId = postReversal?.data?.extTransactionId ? postReversal.data.extTransactionId : null;
        cardToken = postReversal?.data?.tokenInfo?.paymentToken ? postReversal.data.tokenInfo.paymentToken : null;
      }
      updatedCardReversalDetails.push({
        cardAuthorizationId: cardData.cardAuthorizationId.toString(),
        cardAmount: refundAmt.toFixed(2),
        externalTransactionId: externalTransactionId,
        cardToken: cardToken
      });
      console.log("updatedCardReversalDetails", updatedCardReversalDetails);

      const initialAmt2Display: any = [...[], ...amountToDisplay];
      initialAmt2Display[index] = 0;
      setAmountToDisplay(initialAmt2Display);

      setCardReversalDetails(updatedCardReversalDetails);
      setContinueController(iniVal);

      setCCAmount({
        ...CCAmount,
        totalCardPayAmtReversed: (
          Number(CCAmount.totalCardPayAmtReversed) + Number(refundAmt)
        ).toFixed(2),
        totalCardPayEligible: (
          Number(CCAmount.totalCardPayEligible) - Number(refundAmt)
        ).toFixed(2),
      });
      setCardReversal(true);
    } else if (postReversal.status === 400 || postReversal.status === 500) {
      setCardTransactionFailed(true);
      console.log("failedCCAttempt", failedCCAttempt);

      const iniVal: any = [...[], ...failedCCAttempt];
      iniVal[index] = iniVal[index] + 1;
      setFailedCCAttempt(iniVal);

      if (iniVal[index] === 3) {
        const copyContController: any = [...[], ...continueController];
        copyContController[index] = 1;
        console.log("copyContController copyContControol", iniVal);
        setContinueController(copyContController);

        const initialAmt2Display: any = [...[], ...amountToDisplay];
        initialAmt2Display[index] = 0;
        setAmountToDisplay(initialAmt2Display);

        setCardTransactionFailed(false);
        setTransferCOAModel(true);
        setCCAmount({
          ...CCAmount,
          totalCardPayEligible: (
            Number(CCAmount.totalCardPayEligible) - Number(refundAmt)
          ).toFixed(2),
          ...(isMXStore
            ? {
                totalRefundHTSuspense: (
                  Number(CCAmount.totalRefundHTSuspense) + Number(refundAmt)
                ).toFixed(2),
              }
            : {
                totalRefundCOA: (
                  Number(CCAmount.totalRefundCOA) + Number(refundAmt)
                ).toFixed(2),
              }),
        });
      }
    }
  }; // SQ-33 This method will be initiating the reversal of the card payment.

  const invokeSwipeReversal = async (index, cardData, request?) => {
    const amountToReverse = CCAmount.totalCardPayEligible;
    let refundAmt = 0;
    if (
      Number(amountToReverse) -
      (Number(cardData.cardAmount) - Number(cardData.cardAmountReversed)) >
      0
    ) {
      refundAmt =
        Number(cardData.cardAmount) - Number(cardData.cardAmountReversed);
    } else {
      refundAmt = Number(amountToReverse);
    }
    const currentDate = new Date().toJSON().replace("T", "-").replace("Z", "");
    const filterPostalCode = customerInformation.addresses.filter(
      (x) => x.addressTypeDesc == "Primary Address"
    );
    const PaymentInfoObj = {
      TerminalID: selectedTerminal,
      Amount: refundAmt.toFixed(2),
      PaymentDate:
        currentDate.split(".")[0] + ":000" + currentDate.split(".")[1],
      PostalCode: filterPostalCode[0].postalCode.replace("-", ""),
      PaymentType: "2",
      TransactionType: selectedTransactionType,
      RegisterNumber: registerNumber
    };

    const SwipeData = {
      PaymentInfo: PaymentInfoObj,
      storeNumber: window.sessionStorage.getItem("storeNumber"),
    };
    const SwipeCardRequestDTO = isSwipeCustomerCard == 1 ? {
      PaymentInfo: SwipeData.PaymentInfo,
      storeNumber: window.sessionStorage.getItem("storeNumber"),
      clientId: "RACPAD",
      userId: String(employeeId),
      customerId: Number(customerId),
      name: customerInformation?.firstName + " " + customerInformation?.lastName,
      CloudSwipeCustomerCard: Number(isCloudReverseSwipePayment) == 1 ? 'Y' : 'N',
      swipeReversal: "Y"
    } : {
      RefundAmount: refundAmt.toFixed(2),
      CustomerID: customerId,
      UserID: employeeId,
      CloudReverseCCPayment: isCloudReverseCCPayment,
      cardInfo: request,
      reverseSwipePayload: true,
    };
    setCardReversal(false);
    setLoadingModal({ ...loadingModal, reversePay: true });
    try {
      // const postReversal = await ReverseCCPayment({
      //   swipeReversalData: SwipeData,
      //   normalReversalData: null,
      // });
      const postReversal = isSwipeCustomerCard == 1 ? await Swipecustomercard(SwipeCardRequestDTO) :
        await ReverseCCPayment({
          swipeReversalData: null,
          normalReversalData: SwipeCardRequestDTO,
        });
      setLoadingModal({ ...loadingModal, reversePay: false });
      console.log("postReversal", postReversal);
      if (postReversal?.status == 200) {
        console.log("continueController value", continueController);

        const iniVal: any = [...[], ...continueController];
        iniVal[index] = 1;
        console.log("iniVal iniVal", iniVal);

        const updatedCardReversalDetails: any = [...[], ...cardReversalDetails];
        let externalTransactionId: string = CONSTANTS.EMPTY_STRING
        let cardToken: string = CONSTANTS.EMPTY_STRING
        if (isSwipeCustomerCard == 1) {
          externalTransactionId = postReversal?.data?.cardRefNumber ? postReversal.data.cardRefNumber : null;
          cardToken = postReversal?.data?.cardToken ? postReversal.data.cardToken : null;
        } else {
          externalTransactionId = postReversal?.data?.extTransactionId ? postReversal.data.extTransactionId : null;
          cardToken = postReversal?.data?.tokenInfo?.paymentToken ? postReversal.data?.tokenInfo?.paymentToken : null;

        }
        // const externalTransactionId = postReversal?.data?.cardRefNumber ? postReversal.data.cardRefNumber : null;
        // const cardToken = postReversal?.data?.cardToken ? postReversal.data.cardToken : null;
        updatedCardReversalDetails.push({
          cardAuthorizationId: cardData.cardAuthorizationId.toString(),
          cardAmount: refundAmt.toFixed(2),
          externalTransactionId: externalTransactionId,
          cardToken: cardToken
        });
        console.log("updatedCardReversalDetails", updatedCardReversalDetails);

        const initialAmt2Display: any = [...[], ...amountToDisplay];
        initialAmt2Display[index] = 0;
        setAmountToDisplay(initialAmt2Display);

        setCardReversalDetails(updatedCardReversalDetails);
        setContinueController(iniVal);

        setCCAmount({
          ...CCAmount,
          totalCardPayAmtReversed: (
            Number(CCAmount.totalCardPayAmtReversed) + Number(refundAmt)
          ).toFixed(2),
          totalCardPayEligible: (
            Number(CCAmount.totalCardPayEligible) - Number(refundAmt)
          ).toFixed(2),
        });
        setCardReversal(true);
      } else if (postReversal?.status != 200 || postReversal == undefined) {
        setCardTransactionFailed(true);
        console.log("failedCCAttempt", failedCCAttempt);

        const iniVal: any = [...[], ...failedCCAttempt];
        iniVal[index] = iniVal[index] + 1;
        setFailedCCAttempt(iniVal);

        if (iniVal[index] === 3) {
          const copyContController: any = [...[], ...continueController];
          copyContController[index] = 1;
          console.log("copyContController copyContControl", iniVal);
          setContinueController(copyContController);

          const initialAmt2Display: any = [...[], ...amountToDisplay];
          initialAmt2Display[index] = 0;
          setAmountToDisplay(initialAmt2Display);

          setCardTransactionFailed(false);
          setTransferCOAModel(true);
          setCCAmount({
            ...CCAmount,
            totalCardPayEligible: (
              Number(CCAmount.totalCardPayEligible) - Number(refundAmt)
            ).toFixed(2),
            ...(isMXStore
              ? {
                  totalRefundHTSuspense: (
                    Number(CCAmount.totalRefundHTSuspense) + Number(refundAmt)
                  ).toFixed(2),
                }
              : {
                  totalRefundCOA: (
                    Number(CCAmount.totalRefundCOA) + Number(refundAmt)
                  ).toFixed(2),
                }),
          });
        }
      }
    } catch {
      setCardTransactionFailed(true);
      console.log("failedCCAttempt", failedCCAttempt);

      const iniVal: any = [...[], ...failedCCAttempt];
      iniVal[index] = iniVal[index] + 1;
      setFailedCCAttempt(iniVal);

      if (iniVal[index] === 3) {
        const copyContController: any = [...[], ...continueController];
        copyContController[index] = 1;
        console.log("copyContController copyContControl", iniVal);
        setContinueController(copyContController);

        const initialAmt2Display: any = [...[], ...amountToDisplay];
        initialAmt2Display[index] = 0;
        setAmountToDisplay(initialAmt2Display);

        setCardTransactionFailed(false);
        setTransferCOAModel(true);
        setCCAmount({
          ...CCAmount,
          totalCardPayEligible: (
            Number(CCAmount.totalCardPayEligible) - Number(refundAmt)
          ).toFixed(2),
          ...(isMXStore
            ? {
                totalRefundHTSuspense: (
                  Number(CCAmount.totalRefundHTSuspense) + Number(refundAmt)
                ).toFixed(2),
              }
            : {
                totalRefundCOA: (
                  Number(CCAmount.totalRefundCOA) + Number(refundAmt)
                ).toFixed(2),
              }),
        });
      }
    }
  };

  const apiCall = async (postReversalData) => {
    const receiptResponse = await getDocument(
      postReversalData.data.reversedReceiptId,
      "RCP"
    );
    if (
      receiptResponse.status == 200 &&
      Object.keys(receiptResponse.data).length > 0 &&
      receiptResponse.data.fileList[0].fileObject !== null
    ) {
      const Receiptrecord = receiptResponse.data.fileList.filter(
        (x) => x.docType === "PRCT"
      );
      if (Receiptrecord.length) {
        const type = getContentType(Receiptrecord[0]?.fileName);
        setReverseReceiptURL(
          URL.createObjectURL(b64toBlob(Receiptrecord[0]?.fileObject, type))
        );
      }
      console.log("5tyt", Receiptrecord);
      stopFlag = true;
      setOpenViewReceipt(true);
    }
  };

  const carInformationCancelClick = () => {
    setCardInformationPopup(false);
    setModalCardSize({ size: "lg", topic: t('Reverse Payment') })
  }

  const swpieContinueOnclick = () => {

    getRegistrationId(vantivframe, null);

  }


  const isCashAppPayment = () => {
    let isPresent = false;
    if (isEnableCashAppFeature == 1 && reversePayData?.length > 0 && reversePayData[0]?.tenderedTypesUsed?.cardDetails.length > 0) {
      isPresent = reversePayData[0]?.tenderedTypesUsed?.cardDetails.some((el) => el.cardType == CONSTANTS.CARD_TYPE_CASHAPP);
    }
    return isPresent ? true : false
  }

  const invokeGenerateReceipt = async (postReversalData) => {
    setReversedReceiptID(postReversalData.data.reversedReceiptId);
    let receiptTimeOut = true;
    setTimeout(async function () {
      receiptTimeOut = false;
    }, 25000);
    // const paymentReceiptRequest = {
    //   receiptId: Number(postReversalData.data.reversedReceiptId),
    //   resultText: "",
    //   cellPhoneActivation: [],
    // };
    setLoadingModal({ ...loadingModal, document: true });
    while (!stopFlag && receiptTimeOut) {
      await apiCall(postReversalData);
    }
    // const receiptResponse = await ReceiptGeneration(paymentReceiptRequest);
    setLoadingModal({ ...loadingModal, document: false });
    // if (receiptResponse.status === 200) {
    //   setReverseReceiptURL(
    //     URL.createObjectURL(
    //       b64toBlob(receiptResponse.data.receiptHtmlUrl, "text/html")
    //     )
    //   );
    //   console.log("Data Obtained", receiptResponse);
    //   setOpenViewReceipt(true);
    // } else if (receiptResponse.status === 500) {
    //   setExceptionModal({ ...exceptionModal, serverError: true });
    // } else if (receiptResponse.status === 400) {
    //   setExceptionModal({ ...exceptionModal, badRequest: true });
    // }
    if (!stopFlag) {
      setFailedReceiptFetching(true);
      // setExceptionModal({ ...exceptionModal, badRequest: true });
    }
  }; // This method will be fetching the current reversal receipt.

  const acceptCardReversal = async () => {
    setCardReversal(false);
    setStoreExceptionEnable(true)

  }; // SQ-34 This method will be concluding the card reversal by invoking reverse payment API.

  const renderHeader = () => (
    <>
      {CardHeaderData.map((col: string, index: number) => {
        return (
          <RACTableCell
            key={index}
            className={col == "Action" ? `${classes.textCenter}` : ""}
          >
            {t(col)}
          </RACTableCell>
        );
      })}
    </>
  ); // This method will be rendering the header data of the card reversal popup.

  const renderContent = (): any => {
    return gridCardDetails.map((obj, index) => {
      return (
        <React.Fragment key={index}>
          <RACTableRow key={index}>
            <RACTableCell className={`${classes.gridLabel}`}>
              {" "}
              {obj.cardType == CONSTANTS.CARD_TYPE_CASHAPP ? CONSTANTS.CARD_TYPE_CASHAPP : obj.cardLastFour ?? CONSTANTS.HYPHEN}{" "}
            </RACTableCell>
            <RACTableCell className={`${classes.gridLabel}`}>
              {" "}
              {obj.cardAuthNumber}{" "}
            </RACTableCell>
            <RACTableCell className={`${classes.gridLabel}`}>
              {" "}
              ${" "}
              {selectedMasterCheckBox.length
                ? (
                  Number(obj.cardAmount) - Number(obj.cardAmountReversed)
                ).toFixed(2)
                : amountToDisplay[index].toFixed(2)}{" "}
            </RACTableCell>
            <RACTableCell className={`${classes.textCenter}`}>
              <RACButton
                variant="contained"
                color="primary"
                className={`${classes.rcptButton}`}
                onClick={() => {
                  console.log("Inside Reverse onclick")
                  if (obj.cardTransactionType == "SWP") {
                    if (isSwipeCustomerCard == 1) {
                      setOpenTerminalPopup(true)
                      setCardReversal(false);
                    } else {
                      setCardInformationPopup(true);
                      setModalCardSize({ size: 'xs', topic: t('Card Information') })
                    }

                    //setActionTBTOpen(true);
                    setChoosenSwipeData({
                      swipeIndex: index,
                      swipeData: obj,
                    });

                    //  setCardInformationPopup(true)
                  } else {
                    invokeCCReversal(index, obj);
                  }
                }}
                disabled={
                  failedCCAttempt[index] === 3 ||
                    continueController[index] === 1
                    ? true
                    : false
                }
              >
                {t('Reverse')}
              </RACButton>
            </RACTableCell>
          </RACTableRow>
        </React.Fragment>
      );
    });
  }; // This method will be rendering the content data of the card reversal popup.

  const closeCardReversal = () => {
    setCardReversal(false);
    // setReverseReasonValue(ReverseReasonObject);
    // setCardReversalDetails([]);
    if (continueController.some((el) => el === 1)) {
      setPendingReversal(true);
    }
  }; // This method is invoked when cancel button is clicked in the card reversal component.

  const cardReversalRenderer = () => {
    return (
      <>
        {!cardInformationPopup && (
          <Grid>
            <Card className={`${classes.racSkyBlue} ${classes.bluecards} `}>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Grid md={12} className={classes.margincard}>
                    <Typography className={classes.cardPayLabel}>
                      {t('Last Payment Received')}:
                    </Typography>
                  </Grid>
                  <Grid md={12} className={classes.margincard}>
                    <Typography className={classes.cardPayLabel}>
                      {t('Total Cash Payment Eligible for Refund')}:
                    </Typography>
                  </Grid>
                  <Grid md={12} className={classes.margincard}>
                    <Typography className={classes.cardPayLabel}>
                      {isMXStore
                        ? (isEnableCashAppFeature == 1 && isCashAppPayment() && reversePayData[0].tenderedTypesUsed.cardDetails.length == 1 ? t('Total Cash App Refund Moved to HT Suspense:') : isEnableCashAppFeature == 1 && isCashAppPayment() && reversePayData[0].tenderedTypesUsed.cardDetails.length > 1 ? t('Total Card / Cash App Refund Moved to HT Suspense:') : t('Total Card Refund Moved to HT Suspense:'))
                        : (isEnableCashAppFeature == 1 && isCashAppPayment() && reversePayData[0].tenderedTypesUsed.cardDetails.length == 1 ? t('Total Cash App Refund Moved to COA:') : isEnableCashAppFeature == 1 && isCashAppPayment() && reversePayData[0].tenderedTypesUsed.cardDetails.length > 1 ? t('Total Card / Cash App Refund Moved to COA:') : t('Total Card Refund Moved to COA:'))}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={3}>
                  <Grid md={12} className={classes.margincard}>
                    <Typography className={classes.cardPayAmtLabel}>
                      $ {(Number(CCAmount.lastPaymentReceived) + Number(otherAmountToBeAdded) - (Number(otherAmountToBeSub) + Number(otherSusPayAmt))).toFixed(2)}
                    </Typography>
                  </Grid>
                  <Grid md={12} className={classes.margincard}>
                    <Typography className={classes.cardPayAmtLabel}>
                      $ {CCAmount.totalCashPayEligible}
                    </Typography>
                  </Grid>
                  <Grid md={12} className={classes.margincard}>
                    <Typography className={classes.cardPayAmtLabel}>
                      $ {isMXStore ? CCAmount.totalRefundHTSuspense : CCAmount.totalRefundCOA}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid md={12} className={classes.margincard}>
                    <Typography className={classes.cardPayLabel}>
                      {isEnableCashAppFeature == 1 && isCashAppPayment() && reversePayData[0].tenderedTypesUsed.cardDetails.length == 1 ? t('Total Cash App Payment Eligible for Reversal') : isEnableCashAppFeature == 1 && isCashAppPayment() && reversePayData[0].tenderedTypesUsed.cardDetails.length > 1 ? t('Total Card / Cash App Payment Eligible for Reversal') : t('Total Card Payment Eligible for Reversal')}
                    </Typography>
                  </Grid>
                  <Grid md={12} className={classes.margincard}>
                    <Typography className={classes.cardPayLabel}>
                      {isEnableCashAppFeature == 1 && isCashAppPayment() && reversePayData[0].tenderedTypesUsed.cardDetails.length == 1 ? t('Total Cash App Payment Amount Reversed:') : isEnableCashAppFeature == 1 && isCashAppPayment() && reversePayData[0].tenderedTypesUsed.cardDetails.length > 1 ? t('Total Card / Cash App Payment Amount Reversed:') : t('Total Card Payment Amount Reversed:')}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={2}>
                  <Grid md={12} className={classes.margincard}>
                    <Typography className={classes.cardPayAmtLabel}>
                      $ {CCAmount.totalCardPayEligible}
                    </Typography>
                  </Grid>
                  <Grid md={12} className={classes.margincard}>
                    <Typography className={classes.cardPayAmtLabel}>
                      $ {CCAmount.totalCardPayAmtReversed}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
            <Typography className={classes.cctHeading}>
              {t('Current Card Transaction')}
            </Typography>
            <RACTable
              renderTableHead={renderHeader}
              renderTableContent={renderContent}
              className={classes.agrementGridMC}
            />


          </Grid>)}
        {cardInformationPopup && <Grid style={{ float: 'left', width: '100%' }}>
          {/* <h5 style={{ marginBottom: 20, marginTop: '20px' }}>
         Card Information
      </h5> */}
          <Grid style={{ float: 'left', width: '100%' }}>
            <Grid id="chargeframe"></Grid>
          </Grid>
        </Grid>}
        <Grid
          className={`${classes.floatRight} ${classes.w100} ${classes.pt3}`}
        >
          <RACButton
            className={`${classes.floatRight} ${classes.ms2}`}
            color="primary"
            variant="contained"
            disabled={!cardInformationPopup ? disableContinueButton : false}
            onClick={() => { !cardInformationPopup ? acceptCardReversal() : swpieContinueOnclick() }}
          >
            {t('Continue')}
          </RACButton>
          <RACButton
            className={`${classes.floatRight} ${classes.ms2} ${classes.cardPayCancelBtn}`}
            color="primary"
            variant="outlined"
            onClick={() => { !cardInformationPopup ? closeCardReversal() : carInformationCancelClick() }}
          >
            {t('Cancel')}
          </RACButton>
        </Grid>
      </>
    );
  }; // SQ-30 This method will be rendering the card reversal popup for reversing.

  const pendingReversalRenderer = () => {
    return (
      <Grid>
        <Grid className={`${classes.textCenter}`}>
          <AlertIcon />
          <Typography className={`${classes.bold}`}>
            {t('You have initiated a reversal transaction. All credit card reversal transaction must be completed.')}
          </Typography>
          <Typography className={`${classes.bold}`}>
            {t('Please continue!')}
          </Typography>
        </Grid>
        <Grid className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setPendingReversal(false);
              setCardReversal(true);
            }}
          >
            {t('OK')}
          </RACButton>
        </Grid>
      </Grid>
    );
  }; // SQ-31 This method will be rendering the warning message when tring to close the reversal popup after initianing a reversal.

  const transactionFailRenderer = () => {
    return (
      <Grid>
        <Grid className={`${classes.textCenter}`}>
          <AlertIcon />
          {vantivError == CONSTANTS.EMPTY_STRING ? (<><Typography className={`${classes.bold}`}>
            {t('The reverse payment transaction has failed.')}
          </Typography>
            <Typography className={`${classes.bold}`}>
              {t('Please try again!')}
            </Typography></>) :
            <Typography
              className={`${classes.modalfooter} ${classes.textcenter} ${classes.w100} ${classes.mt3}`}
            >
              {t(vantivError)}
            </Typography>}
        </Grid>
        <Grid className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setCardTransactionFailed(false);
              vantivError != CONSTANTS.EMPTY_STRING ?
                setVantivError(CONSTANTS.EMPTY_STRING) :
                setCardReversal(true);
            }}
          >
            {t('OK')}
          </RACButton>
        </Grid>
      </Grid>
    );
  }; // Sq-32 This method will be rendering the exception message when the transaction got failed.

  const transferCOARenderer = () => {
    return (
      <Grid>
        <Grid className={`${classes.textCenter}`}>
          <AlertIcon />
          <Typography className={`${classes.bold}`}>
            {t('Multiple unsuccessful reversal attempts.')}
          </Typography>
          <Typography className={`${classes.bold}`}>
            {isMXStore
              ? t('Fund will be moved to HT Suspense.')
              : t('Fund will be moved to Credit on Account.')}
          </Typography>
        </Grid>
        <Grid className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setTransferCOAModel(false);
              setCardReversal(true);
            }}
          >
            {t('OK')}
          </RACButton>
        </Grid>
      </Grid>
    );
  }; // This method will be rendering the confirmation popup while trransfering the amount to COA.

  // const actionTBTRenderer = () => {
  //   return (
  //     <Grid>
  //       <Grid className={`${classes.textCenter}`}>
  //         <AlertIcon />
  //         <Typography className={`${classes.bold}`}>
  //           Select Action To Be Taken At Device.
  //         </Typography>
  //       </Grid>
  //       <Grid className={`${classes.py4} ${classes.textCenter}`}>
  //         <RACButton
  //           className={classes.mx1}
  //           variant="contained"
  //           color="primary"
  //           onClick={() => {
  //             setActionTBTOpen(false);
  //             setOpenTerminalPopup(true);
  //             setSelectedTransactionType("2");
  //           }}
  //         >
  //           Swipe Card
  //         </RACButton>
  //         <RACButton
  //           className={classes.mx1}
  //           variant="contained"
  //           color="primary"
  //           onClick={() => {
  //             setActionTBTOpen(false);
  //             setOpenTerminalPopup(true);
  //             setSelectedTransactionType("1");
  //           }}
  //         >
  //           Card Not Present
  //         </RACButton>
  //       </Grid>
  //     </Grid>
  //   );
  // };

  const bindTerminalList = () => {
    return availableSwipeDevices?.map((values: any, index: any) => {
      console.log("index in dd bind", index);
      if (index === 0 && values.description == "No reasons") {
        return { label: "No Records Found", value: values.referenceCode };
      } else if (index === 0) {
        return { label: "Select", value: values.referenceCode };
      } else {
        // const storeNumber = String(Number(values.storeNumber));
        const terminalId = String(values.termNumber)?.slice(-3)
        return { label: values.name, value: terminalId };
      }
    });
  };

  const renderTerminalPopup = () => {
    const amountToReverse = CCAmount.totalCardPayEligible;
    let refundAmt = 0;
    if (
      Number(amountToReverse) -
      (Number(choosenSwipeData?.swipeData.cardAmount) -
        Number(choosenSwipeData?.swipeData.cardAmountReversed)) >
      0
    ) {
      refundAmt =
        Number(choosenSwipeData?.swipeData.cardAmount) -
        Number(choosenSwipeData?.swipeData.cardAmountReversed);
    } else {
      refundAmt = Number(amountToReverse);
    }
    return (
      <Grid item>
        <Grid container justifyContent={"center"}>
          <Grid item md={12} className={`${classes.mb3} ${classes.ps2}`}>
            <Typography
              variant="caption"
              className={`${classes.RAClabeltxtstyle} ${classes.semibold}`}
            >
              Amount to be reversed:{" "}
            </Typography>
            <Typography
              variant="caption"
              className={`${classes.RACvaluetxtstyle} ${classes.bold}`}
            >
              ${refundAmt.toFixed(2)}
            </Typography>
          </Grid>
          <Grid item md={12} className={`${classes.mb3} ${classes.ps2}`}>
            <Grid
              item
              md={12}
              className={`${classes.formLabel} ${classes.w100} ${classes.floatLeft} ${classes.mt2}`}
            >
              Computer Name
            </Grid>
            <Grid
              item
              md={12}
              className={`${classes.mb3} ${classes.w100} ${classes.floatLeft}`}
            >
              <RACSelect
                options={bindTerminalList()}
                isDisabled={availableSwipeDevices?.length === 1 ? true : false}
                defaultValue={
                  selectedTerminal !== "" ? selectedTerminal : "SELECT"
                }
                onChange={(e) => {
                  setSelectedTerminal(
                    e.target.value == "SELECT" ? "" : e.target.value
                  );
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          md={12}
          className={`${classes.justifyContentRight} ${classes.mt4}`}
        >
          <RACButton
            className={`${classes.me2}`}
            variant="outlined"
            color="primary"
            onClick={() => {
              setOpenTerminalPopup(false);
              setCardReversal(true);
              //setActionTBTOpen(true);
              setSelectedTerminal("");
            }}
          >
            {t('Cancel')}
          </RACButton>

          <RACButton
            color="primary"
            variant="contained"
            disabled={selectedTerminal == "" ? true : false}
            onClick={() => {
              setOpenTerminalPopup(false);
              invokeSwipeReversal(
                choosenSwipeData.swipeIndex,
                choosenSwipeData.swipeData
              );
            }}
          >
            {t('Next')}
          </RACButton>
        </Grid>
      </Grid>
    );
  };
  const storeExceptionCompleted = async (updatedPayload?) => {
    debugger
    setStoreExceptionEnable(false)
    const StoreExceptionPayload = updatedPayload
    let cardAmountReversed = 0;
    if (cardReversalDetails.length) {
      cardReversalDetails.map((obj) => {
        cardAmountReversed =
          Number(cardAmountReversed) + Number(obj.cardAmount);
      });
    }
    const isConvenienceFeeUsed = reversePayData[0].otherPaymentAmount.filter((el) => el.accountType == 'CONVENFEETAX' || el.accountType == 'CONVENFEE');
    const totalRefundToAccount = isMXStore
      ? CCAmount.totalRefundHTSuspense
      : CCAmount.totalRefundCOA;
    const postCardReversalData = {
      storeNumber: String(window.sessionStorage.getItem("storeNumber")),
      customerId: customerId,
      reasonType: reverseReasonValue.reverseReason,
      reasonText: reverseReasonValue.reasonInformation,
      receiptInfo: [
        {
          receiptId:
            reversePayData !== undefined ? reversePayData[0].receiptId : "",
          agreementId: selectedAgreements.length ? selectedAgreements : null,
          inventoryId: selectedInventories.length ? selectedInventories : undefined,
          isClubReversible: isClubReversible,
          reversedAmount: isConvenienceFeeUsed.length > 0 ? undefined : (
            Number(CCAmount.totalCashPayEligible) +
            Number(cardAmountReversed) +
            Number(totalRefundToAccount)
          ).toFixed(2),
          reverseToCoaAmount: isMXStore ? undefined : CCAmount.totalRefundCOA,
          reverseToHTSuspenseAmount: isMXStore ? CCAmount.totalRefundHTSuspense : undefined,
          cardReversalDetails: cardReversalDetails,
        },
      ],
    };
    console.log("postCardReversalData", postCardReversalData);

    setLoadingModal({ ...loadingModal, reversePay: true });
    const postReversal = await postReversePayment(postCardReversalData);
    setLoadingModal({ ...loadingModal, reversePay: false });
    if (postReversal.status === 200) {
      if (postReversal?.data && StoreExceptionPayload) {
        const payload = StoreExceptionPayload?.map((obj) => {
          return obj.identifierId = Number(postReversal?.data?.reversedReceiptId)
        })
        const Request = {
          storeException: StoreExceptionPayload
        }
        storeException(Request);
        setStoreExceptionPayload([])

      }
      invokeGenerateReceipt(postReversal);
    } else if (postReversal.status === 400) {
      // setExceptionModal({ ...exceptionModal, badRequest: true });
      setIsPostReversalFailed(true);
    } else if (postReversal.status === 500) {
      setExceptionModal({ ...exceptionModal, serverError: true });
    }

  }
  const storeExceptionCancelled = async () => {
    debugger
    setStoreExceptionEnable(false);
    setCardReversal(false);
    // setReverseReasonValue(ReverseReasonObject);
    // setCardReversalDetails([]);
    if (continueController.some((el) => el === 1)) {
      setPendingReversal(true);
    }
  }
  return (
    <>
      {StoreExceptionEnable ? (<StoreException
        refCode={'RFN'}
        identifierType={'RECEIPT'}
        storeExceptionCancelled={storeExceptionCancelled}
        storeExceptionCompleted={storeExceptionCompleted}
      />) : null}
      <RACModalCard
        isOpen={cardReversal}
        maxWidth={modalCardSize.size}
        borderRadius={ModalRadius}
        closeIcon={true}
        title={modalCardSize.topic}
        onClose={() => { !cardInformationPopup ? closeCardReversal() : carInformationCancelClick() }}
        //eslint-disable-next-line react/no-children-prop
        children={cardReversalRenderer()}
      />
      <RACModalCard
        isOpen={pendingReversal}
        maxWidth="xs"
        borderRadius={ModalRadius}
        //eslint-disable-next-line react/no-children-prop
        children={pendingReversalRenderer()}
      />
      {/* <RACModalCard
        isOpen={actionTBTOpen}
        maxWidth="xs"
        closeIcon={true}
        onClose={() => {
          setActionTBTOpen(false);
          setCardReversal(true);
        }}
        borderRadius={ModalRadius}
        //eslint-disable-next-line react/no-children-prop
        children={actionTBTRenderer()}
      /> */}
      <RACModalCard
        isOpen={cardTransactionFailed}
        maxWidth="xs"
        borderRadius={ModalRadius}
        //eslint-disable-next-line react/no-children-prop
        children={transactionFailRenderer()}
      />
      <RACModalCard
        isOpen={transferCOAModel}
        maxWidth="xs"
        borderRadius={ModalRadius}
        //eslint-disable-next-line react/no-children-prop
        children={transferCOARenderer()}
      />
      <RACModalCard
        isOpen={openTerminalPopup}
        maxWidth="xs"
        title="Swipe Card"
        borderRadius={ModalRadius}
        //onClose={() => setCardrequire({ ...Cardrequire, swipcard: false })}
        // eslint-disable-next-line react/no-children-prop
        children={renderTerminalPopup()}
      />
      {/* <RACModalCard
        isOpen={cardInformationPopup}
        maxWidth="xs"
        title="Swipe Card"
        borderRadius={ModalRadius}
        //onClose={() => setCardrequire({ ...Cardrequire, swipcard: false })}
        // eslint-disable-next-line react/no-children-prop
        children={renderSwipeCardPopup()}
      /> */}
    </>
  );
}
